import { CommonDT, PageQueryParams, RestResponse } from './CommonDT';
import { _get, _post, _req } from '../../request';
import { termsDataType } from './term-api';
import { coactsDataType } from './coast-api';
import { UserDataType } from '../sys/user-api';
import { PostDownloadTypeEnum } from 'services/gather_bo/_total';

export type PostsDataType = CommonDT & {
  postUuid: string;
  postIncId: number;
  postTitle: string;
  postContent: string;
  postExcerpt: string;
  postPassword: string;
  postCoverUrlList: string[];
  postSlug: string;
  postType: string;
  postStatus: string;
  postCommentStatus: string;
  postSourceUrl: string;
  postSourceType: string;
  // postSourceInfo: T; // 只在后端使用
  postDownloadInfo: PostDownloadDto[];
  postUpdateTime: string;
  postUploadTime: string;
  fkAuthorUuid: string;
  fkUpperPostUuid: string;
};

export type PostDownloadDto = {
  downloadUuid: String;
  downloadTypeCode: String;
  downloadUrl: String;
  downloadNotice: String;
  extractionCode: String;
  decompressionCode: String;
};

export type PostContentDto<T, K> = {
  metaInfo: T;
  contentInfo: K;
};

export type PagePostDT = PostsDataType & {
  asTerms: termsDataType;
  asCoacts: coactsDataType;
  asUser: UserDataType;
};

export type PostDetail<T, K> = PostsDataType & {
  postContentDto: PostContentDto<T, K>;
  asTerms: termsDataType;
  asTagList: termsDataType[];
  asTopicsList: termsDataType[];
  asCoacts: coactsDataType;
  asUser: UserDataType;
};

export type PostDto<T> = {
  chapterList: T[];
  pageLabel: string;
  metaInfo: {
    galleryCategory: string;
    tagMap: Map<string, string[]>;
    archiveSize: string;
  };
};

export type VideoPlayUrlList = {
  no: number;
  name: string;
  url: string;
  type?: string;
}[];

// export type ChapterDto = {
//   chapterNo: number;
//   chapterName: string;
//   resourceList: {
//     resourceNo: number;
//     resourceGatId: number;
//     coverPath: string;
//     resourcePath: string;
//   }[];
// };

export type AlterPostTerm = {
  postId: string;
  taxonomyDTOList: {
    termTaxonomy: string;
    termIdList: string[];
  };
};

/**
 * ==========================================================
 * ========================公共接口===========================
 * ==========================================================
 */
const get = async (id: any): Promise<RestResponse> => {
  return await _get('/cnt/posts/get/', id);
};

const page = async (
  params: {
    cantCache?: boolean;
    termId?: string;
    termTaxonomy?: string;
    osusume?: boolean;
  },
  data: PageQueryParams
): Promise<RestResponse> => {
  return await _req('/cnt/posts/page', 'POST', params, data);
};

const pageOsusume = async (params: { termId: string; count: number }): Promise<RestResponse> => {
  return await _req('/cnt/posts/pageOsusume', 'GET', params);
};

const polyOsusume = async (
  params: { termId: string; osusumeLevel: number },
  data: PageQueryParams
): Promise<RestResponse> => {
  return await _req('/cnt/posts/polyOsusume', 'POST', params, data);
};

const saveBatch = async (dataList: PostsDataType): Promise<RestResponse> => {
  return await _post('/cnt/posts/saveBatch', dataList);
};

const alterBatch = async (dataList: PostsDataType): Promise<RestResponse> => {
  return await _post('/cnt/posts/alterBatch', dataList);
};

const removeBatch = async (idList: string[]): Promise<RestResponse> => {
  return await _post('/cnt/posts/removeBatch', idList);
};

/**
 * ==========================================================
 * ========================特有接口===========================
 * ==========================================================
 */
const other = async (params: {}, body: {}): Promise<RestResponse> => {
  return await _req('/cnt/posts/other', 'POST', params, body);
};
const alterPostAllTerm = async (params: {}, data: AlterPostTerm[]): Promise<RestResponse> => {
  return await _req('/cnt/posts/alterPostAllTerm', 'POST', params, data);
};
const getDetail = async (params: { postId: any }, data: {}): Promise<RestResponse> => {
  return await _req('/cnt/posts/getDetail', 'GET', params, data);
};
const getVideoPlayUrl = async (
  params: {},
  data: { postSourceType: string; postSourceUrl: string }
): Promise<RestResponse> => {
  return await _req('/cnt/posts/getVideoPlayUrl', 'POST', params, data);
};
const getPostCount = async (params: { termId: any; termTaxonomy: string }): Promise<RestResponse> => {
  return await _req('/cnt/posts/getPostCount', 'GET', params);
};

const alterPostDownloadInfo = async (
  params: { postId: string },
  data: { postDownloadInfo: PostDownloadDto }
): Promise<RestResponse> => {
  return await _req('/backend/cnt/posts/alterPostDownloadInfo', 'POST', params, data.postDownloadInfo);
};
const addPostDownloadInfo = async (
  params: { postId: string },
  data: { postDownloadInfo: PostDownloadDto }
): Promise<RestResponse> => {
  return await _req('/backend/cnt/posts/addPostDownloadInfo', 'POST', params, data.postDownloadInfo);
};
const delPostDownloadInfo = async (params: { postId: string; postDownloadInfoId: string }): Promise<RestResponse> => {
  return await _req('/backend/cnt/posts/delPostDownloadInfo', 'POST', params);
};

const PostsApi = {
  get,
  page,
  pageOsusume,
  polyOsusume,
  saveBatch,
  alterBatch,
  removeBatch,
  other,
  alterPostAllTerm,
  getDetail,
  getVideoPlayUrl,
  getPostCount,
  delPostDownloadInfo,
  alterPostDownloadInfo,
  addPostDownloadInfo,
};

export default PostsApi;
